module.exports = __webpack_public_path__ + "media/images/emblems/Ettiswil_LU-05b2a8fab698734976444167ebbe6b5e.png";